module.exports = __webpack_public_path__ + "static/1-bf51cad18180bed2ba772a449b5bc302.png";